import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description SmilesSad icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { SmilesSad } from '@sravni/design-system-icons'
 *
 * <SmilesSad />
 * ```
 */
var SmilesSad = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "SmilesSad", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "M15.303 4.697A7.5 7.5 0 1 1 4.697 15.303 7.5 7.5 0 0 1 15.303 4.697ZM7.083 7.5v.833M12.917 7.5v.833", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M7.083 13.333S8.177 12.24 10 12.24c1.823 0 2.917 1.093 2.917 1.093", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { SmilesSad };
//# sourceMappingURL=SmilesSad.js.map
